import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

export function sendSubscribeToNewsletterEvent() {
  sendDataLayerEvent(EventNamesType.subscribe_to_newsletter);
}
